import styled, { keyframes } from 'styled-components';
import imgBg from '../assets/imgs-background/background1.png';

export const rotateAnimation = keyframes`
from {
  transform: rotate(0deg);
}
to {
  transform: rotate(360deg);
}
`;
export const reverseRotation = keyframes`
from {
  transform: rotate(360deg);
}
to {
  transform: rotate(0deg);
}
`;

export const TanqueStyled = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 25%;
  min-height: 100vh;
  min-height: 100vh;
  width: 100%;
  background-image: url(${imgBg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  .desativado {
    opacity: 40%;
    cursor: no-drop;
  }
  .sectionTanque {
    display: flex;
    flex-direction: column;
    align-items: center;
    /* justify-content: center; */
    gap: 25%;
    width: 94%;
    height: fit-content;
    min-height: 95vh;
    margin-left: 60px;
    margin-top: 20px;

    background-color: rgba(0, 0, 0, 0.41);
    margin-bottom: 50px;
    border-radius: 5px;
    .avisos {
      position: absolute;
      top: 30px;
      right: 30px;
      font-size: 40px;
      color: rgba(126, 124, 125, 1);
      cursor: pointer;
      transition: 0.5s;
      z-index: 2;
    }
    .avisos:hover {
      color: rgba(180, 180, 180, 1);
    }
    .containerSuperior {
      display: flex;
      width: 100%;
      padding: 10px;
      height: 50vh;
      max-height: 50vh;
      position: relative;
      .close {
        position: absolute;
        top: 10px;
        font-size: 35px;
        left: 66%;
        color: rgba(143, 143, 143, 0.8);
        cursor: pointer;
        transition: 0.5s;
        z-index: 10;
      }
      .close:hover {
        color: rgba(193, 193, 193, 0.8);
      }
      .graficos {
        width: 70%;
        /* height: 100%; */
        border-bottom: 2px solid rgba(165, 165, 165, 0.8);
        border-right: 2px solid rgba(165, 165, 165, 0.8);
      }
      .containerAlertas {
        width: 30%;
        /* height: 100%; */
        max-height: 50vh;
        /* overflow: auto; */
        border-bottom: 2px solid rgba(165, 165, 165, 0.8);
        position: relative;
        .alertas {
          width: 100%;
          height: 50%;
          max-height: 60%;
          color: rgba(187, 187, 187, 0.8);
          h4 {
            display: flex;
            justify-content: center;
            width: 100%;
            align-items: center;
            margin-top: 10px;
            font-size: 22px;
            color: rgba(170, 170, 170, 1);
          }

          div {
            width: 100%;
            height: 100%;
            max-height: 100%;
            flex-grow: 1; /* Faz com que o div ocupe todo o espaço disponível na altura */
            display: flex;
            flex-direction: column;
            gap: 5px;
            padding: 15px;
            overflow-y: auto; /* Adicionado para habilitar a rolagem vertical se o conteúdo for maior do que o espaço disponível */
            span {
              border-bottom: 2px solid rgba(109, 109, 109, 0.74);
            }
          }
        }
        .buttons {
          width: 100%;
          height: 45%;
          max-height: 50%;
          display: flex;
          flex-direction: column;
          justify-content: end;
          padding: 5px;
          gap: 10px;
          max-height: 100%;
          button {
            height: 60px;
            font-size: 20px;
            font-weight: 600;
            max-height: 100%;
            background-color: var(--bgBotao);
            color: var(--bgBranco);
            border-radius: 10px;
            border: 2px solid rgba(0, 0, 0, 0);
          }
          .btnStatus {
            cursor: pointer;
          }
          .btnStatus:hover {
            border: 2px solid var(--bgBranco);
          }
        }
      }
    }
    .containerInferior {
      width: 100%;
      padding: 15px;
      ul {
        width: 100%;
        display: flex;
        justify-content: center;
        /* align-items: center; */
        gap: 10px;
        list-style: none;
        flex-wrap: wrap;
        li {
          display: flex;
          gap: 15px;
          align-items: center;
          max-width: 100%;
          h3 {
            border: 2px solid rgba(78, 78, 78, 1);
            background-color: rgba(195, 195, 195, 0.8);
            color: rgb(29, 29, 29);
            padding: 10px;
            border-radius: 5px;
            cursor: pointer;
          }
          display: flex;
          flex-direction: column;
          .containerInfos {
            position: relative;
            .ping {
              /* width: 50px;
              height: 50px; */
              position: absolute;
              top: -8px;
              right: 30px;
              display: none;
              button {
                padding: 2px 4px;
                border-radius: 5px;
                cursor: pointer;
                border: 2px solid rgba(104, 104, 104, 0.71);
                background-color: rgba(197, 197, 197, 0.88);
              }
            }

            .gtwStatus {
              position: absolute;
              top: -7px;
              right: 15px;
              font-size: 19px;
              color: rgb(255, 255, 255);
              background-color: rgba(0, 0, 0, 0.6);
              border-radius: 50%;
              border: 1px solid rgba(197, 197, 197, 0.71);
            }
            .gtwStatus:hover + .ping {
              display: flex;
            }
            .ping:hover {
              display: flex;
            }
            .PingGTWOFF {
              opacity: 30%;
            }
            .gtwStatusON {
              color: rgb(3, 219, 10);
            }
            .gtwStatusOFF {
              color: rgb(246, 22, 22);
            }
            .tanqueOn {
              display: flex;
              width: 17px;
              height: 17px;
              border-radius: 50%;
              background-color: rgb(3, 140, 8);
              border: 1px solid rgb(197, 197, 197);
              position: absolute;
              right: -6px;
              top: -6px;
            }
            .tanqueOff {
              display: flex;
              width: 17px;
              height: 17px;
              border-radius: 50%;
              background-color: rgb(201, 0, 0);
              border: 1px solid rgb(197, 197, 197);
              position: absolute;
              right: -6px;
              top: -6px;
            }
            display: flex;
            gap: 20px;

            max-width: 100%;
            background: rgba(0, 0, 0, 0.5);
            background: -moz-linear-gradient(
              0deg,
              rgba(140, 140, 140, 0.6) 0%,
              rgba(237, 237, 237, 0.6) 100%
            );
            background: -webkit-linear-gradient(
              0deg,
              rgba(140, 140, 140, 0.6) 0%,
              rgba(237, 237, 237, 0.6) 100%
            );
            background: linear-gradient(
              0deg,
              rgba(140, 140, 140, 0.6) 0%,
              rgba(237, 237, 237, 0.6) 100%
            );

            padding: 10px;
            padding-bottom: 6px;
            border: 2px solid rgba(57, 57, 57, 1);
            border-radius: 4px;
            align-items: center;
            min-width: 420px;
            min-height: 275px;
            .conteinerLimite {
              display: flex;
              width: 100%;
              justify-content: space-between;
              /* max-height: 147px; */
              align-items: center;
              /* overflow: scroll; */
            }
          }
          .infos {
            display: flex;
            flex-direction: column;
            gap: 10px;
            align-items: center;
            justify-content: flex-start;
            min-height: 80px;
            /* background: rgba(0, 0, 0, 0.5); */
            position: relative;
            margin-right: 50px;
            min-height: 190px;

            .barraNivelVerticalWrapper {
              height: 200px;
              width: 55px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              gap: 6px;
              font-size: 11px;
              color: #555;
              position: absolute;
              top: -18px;
              right: -50px;

              span {
                color: #000000;
              }
            }

            .barraNivelVertical {
              position: relative;
              width: 22px;
              height: 200px;
              border-radius: 999px;
              background: #e5e5e5;
              border: 1px solid #ccc;
              overflow: hidden;
            }

            .barraNivelVerticalAtual {
              position: absolute;
              bottom: 0;
              width: 100%;
              height: var(--nivel);
              border-radius: 999px;

              background: linear-gradient(
                to top,
                #19c85f 0%,
                #19c85f 35%,

                #d6d600 45%,
                #ffb000 70%,

                #ff7a00 80%,
                #e60000 100%
              );

              background-size: 100% 165px;
              background-position: bottom;

              transition: height 0.4s ease;
            }
            .info {
              width: 100%;
              display: flex;
              justify-content: space-between;
              gap: 10px;
              font-weight: 600;
              font-size: 18px;

              p {
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 17px;
                text-align: center;
                width: 100%;
              }
              span {
                background: rgba(218, 218, 218, 1);
                padding: 2px;
                border: 1px solid rgba(47, 47, 47, 1);
                border-radius: 5px;
                font-size: 16px;
                width: 100px;
                text-align: center;
              }
            }
          }

          .info {
            width: 100%;
            display: flex;
            justify-content: center;
            gap: 10px;
            font-weight: 600;
            font-size: 18px;

            p {
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 17px;
              text-align: center;
              width: 100%;
            }
            span {
              background: rgba(218, 218, 218, 1);
              padding: 2px;
              border: 1px solid rgba(47, 47, 47, 1);
              border-radius: 5px;
              font-size: 16px;
              width: 100px;
              text-align: center;
            }
          }
          .conteinerStatus {
            display: flex;
            flex-direction: column;
            min-height: 225px;
            /* background-color: #00000077; */

            .status {
              display: flex;
              align-items: center;
              flex-direction: column;
              align-items: center;
              height: 100%;
              gap: 10px;
              font-weight: 600;
              .controle {
                display: flex;
                justify-content: space-around;
                width: 100%;

                .divControler {
                  display: flex;
                  gap: 5px;
                  align-items: center;
                  flex-direction: column;
                  justify-content: center;
                  p {
                    font-size: 15px;
                  }
                }
                border-bottom: 2px solid rgba(47, 47, 47, 0.62);
              }
              .Bombas {
                display: flex;
                flex-direction: column;
                gap: 5px;

                span {
                  text-align: center;
                  /* background: rgba(218, 218, 218, 1); */
                  /* padding: 5px 25px; */
                  /* border: 1px solid rgba(47, 47, 47, 1); */
                  /* border-radius: 5px; */

                  /* border-top: 2px solid rgba(47, 47, 47, 0.62); */
                  padding-top: 5px;
                  font-weight: 600;
                  max-width: 200px;
                }
                button {
                  display: flex;
                  align-items: end;
                  justify-content: center;
                  gap: 5px;
                  background-color: rgba(69, 71, 70, 0.1);
                  border: 1px solid rgba(47, 47, 47, 1);
                  border-radius: 10px;
                  padding: 5px 25px;
                  font-weight: 600;
                  color: rgba(36, 36, 36, 1);
                  cursor: pointer;
                  font-weight: 600;
                  .icon {
                    font-size: 16px;
                  }

                  .IconeOn {
                    /* background-color: gray; */
                    text-shadow: 2px 2px 10px rgb(255, 64, 6);
                    /* -webkit-box-shadow: inset 0px 0px 50px 0px #000000;
                    box-shadow: inset 0px 0px 50px 0px rgba(0, 255, 106, 0.14); */
                    border-radius: 50%;
                    filter: drop-shadow(0px 0px 2px rgba(48, 223, 9, 0.6));
                  }
                }
                .btndesativado {
                  opacity: 0.5;
                }
                .butonOff {
                  cursor: not-allowed;
                  opacity: 40%;
                  animation: ${rotateAnimation} 2s linear infinite;
                }
              }
            }
          }
        }
      }
    }
  }
  @media (max-width: 650px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: end;
    padding: 10px;
    .sectionTanque {
      width: 100%;
      margin-left: 0px;
      margin-top: 5px;
      .containerSuperior {
        .graficos {
          width: 100%;
        }
        .containerAlertas {
          display: none;
        }
      }

      .containerInferior {
        ul {
          justify-content: center;
          li {
            .containerInfos {
              justify-content: center;
              min-width: 200px;
              width: 350px;
              max-width: 100%;

              .conteinerLimite {
                align-items: center;
                /* justify-content: center; */
                max-height: min-content;
                gap: 2px;
                width: 100%;
                flex-direction: column;
                /* background-color: #19c85f; */
              }
              .barraNivelVerticalWrapper {
                top: 60px;
                right: -80px;
                height: 200px;
              }
              .infos {
                align-items: center;
                justify-content: center;
                .info {
                  gap: 0px;
                }
              }
              .conteinerStatus {
                align-items: center;
                justify-content: center;
              }
            }
          }
        }
        .containerInfos {
          flex-wrap: wrap;
          .conteinerStatus {
            gap: 20px;
          }
        }
      }
    }
  }
`;

export const CxControle = styled.div`
  /* padding: 15px; */
  width: 30px;
  max-width: 100%;
  height: 25px;
  border-radius: 5px;
  border: 1px solid rgb(0, 0, 0);
  background: ${(props) => props.activo};
`;

export const ModalBombaTanque = styled.div`
  display: flex;
  justify-content: center;
  align-items: end;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  height: 100vh;
  max-height: 100%;
  background-color: rgba(0, 0, 0 0.3);
  backdrop-filter: blur(10px);
  position: fixed;
  z-index: 9;
  top: 0;
  left: 0;
  box-shadow: 1px 2px 31px 0px rgba(255, 255, 255, 0.41);
  -webkit-box-shadow: 1px 2px 31px 0px rgba(255, 255, 255, 0.41);
  -moz-box-shadow: 1px 2px 31px 0px rgba(255, 255, 255, 0.41);
  padding-right: 50px;
  .confimation {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    max-height: 100%;
    background-color: rgba(18, 18, 20, 0.3);
    z-index: 50;
    .ConfirmationChanges {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 600px;
      max-width: 80%;
      background-color: rgba(18, 18, 20, 0.9);
      border: 2px solid #b2b2b2;
      padding: 20px;
      border-radius: 15px;
      gap: 15px;
      h2 {
        color: white;
        text-align: center;
      }
      div {
        display: flex;
        gap: 15px;
        width: 100%;
        button {
          width: 100%;
          height: 50px;
          font-size: 1rem;
          font-family: 'Inter', sans-serif;
          color: #ffffff;
          border: none;
          background-color: rgba(195, 13, 26, 1);
          border-radius: 8px;
          cursor: pointer;
        }
        .buttonYes {
          background-color: transparent;
          color: rgba(1, 255, 24, 1);
          border: 2px solid rgba(1, 255, 24, 1);
          transition: 1s;
        }
        .buttonYes:hover {
          background-color: rgba(5, 164, 21, 1);
          color: white;
        }
      }
    }
  }
  .conteiner {
    display: flex;
    flex-direction: column;
    width: 92%;
    height: 85%;
    background-color: rgba(143, 143, 143, 0.94);
    border-radius: 5px;
    border: 2px solid rgb(62, 62, 62);
    position: relative;
    padding: 18px;
    gap: 25px;
    overflow: auto;
    h3 {
      font-size: 25px;
      color: rgba(47, 47, 47, 1);
    }
    .creatNivel {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 5px;
      cursor: pointer;
      position: absolute;
      left: 40%;
      .icon {
        font-size: 25px;
        color: rgba(46, 46, 46, 1);
        transition: 0.5s;
      }
      .icon:hover {
        color: rgba(0, 0, 0, 1);
      }
    }
    .closeModal {
      position: absolute;
      top: 5px;
      right: 5px;
      font-size: 35px;
      color: rgba(64, 64, 64, 1);
      cursor: pointer;
      transition: 0.5s;
    }
    .closeModal:hover {
      color: black;
    }
    ul {
      list-style: none;
      display: flex;
      gap: 25px;
      flex-wrap: wrap;
      li {
        width: 200px;
        display: flex;
        flex-direction: column;
        gap: 15px;
        width: 350px;
        min-height: 40px;
        max-width: 100%;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 10px;
        box-shadow: 0 0px 30px 0 rgba(232, 232, 232, 0.2);
        padding: 15px;
        color: rgba(203, 203, 203, 1);
        padding-top: 50px;
        position: relative;
        .deleteBomba {
          position: absolute;
          top: 5px;
          right: 15px;
          font-size: 29px;
          cursor: pointer;
          transition: 0.5s;
        }
        .deleteBomba:hover {
          color: rgba(216, 84, 84, 0.8);
        }
        .IdBomba {
          position: absolute;
          font-size: 17px;
          font-weight: 600;
          top: 10px;
          left: 35%;
          color: rgba(239, 239, 239, 1);
        }
        .headerLi {
          position: absolute;
          top: 20px;
          left: 38%;
          font-size: 18px;
          font-weight: 600;
        }

        .buttons {
          display: flex;
          gap: 5px;

          button {
            height: 40px;
            width: 100%;
            background: rgba(0, 0, 0, 0.2);
            border: 2px solid rgba(203, 203, 203, 0.3);
            color: rgba(203, 203, 203, 1);
            border-radius: 5px;
            cursor: pointer;
            transition: 0.8s;
          }
          .off {
            opacity: 50%;
            cursor: no-drop;
          }
          button:hover {
            background: rgba(0, 0, 0, 0.4);
            color: rgba(255, 255, 255, 1);
            border: 2px solid rgba(255, 255, 255, 1);
          }
        }
        .infosPivo {
          display: flex;
          flex-direction: column;
          gap: 20px;
          position: relative;
          height: 47px;
          p {
            font-weight: 600;
          }
          label {
            font-weight: 600;
            color: rgba(207, 207, 207, 1);
            background: linear-gradient(to top, rgba(29, 29, 29, 0.95) 50%, transparent 50%);
            max-width: max-content;
            padding: 0px 4px;
            position: absolute;
            top: -11px;
            left: 15px;
            /* text-shadow: -1px -2px 8px rgba(255, 255, 255, 0.8); */
          }
          input {
            padding: 15px 20px;
            border-radius: 15px;
            border: 1px solid black;
            background-color: rgba(29, 29, 29, 0.95);
            box-shadow: 0px -14px 55px -4px rgba(0, 0, 0, 0.3);
            -webkit-box-shadow: 0px -14px 55px -4px rgba(0, 0, 0, 0.3);
            -moz-box-shadow: 0px -14px 55px -4px rgba(0, 0, 0, 0.3);
            color: rgba(216, 216, 216, 1);
          }
        }
      }
    }
  }
`;
